import React from "react";

export default function Textarea({ placeholder, required, className }) {
  return (
    <div className={`relative ${className}`}>
      <textarea
        className={`min-h-[150px] text-[14px] font-[500] font-primary leading-[130%] font-primary focus:placeholder-black focus:outline-none w-full py-[13px] px-[15px] bg-transparent border-[1px] border-[#fff] text-[#fff] placeholder-white`}
        placeholder={placeholder}
        required={required}
      />
    </div>
  );
}
